import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Office365Service {

  url = "/api/microsoft";

  constructor(private http: HttpClient) { }

  authorize(id): Observable<object> {
    return this.http.get<object>(this.url + "/office365/" + id + "/authorize");
  }

  me(id): Observable<object> {
    return this.http.get<object>(this.url + "/office365/" + id + "/me");
  }

  users(id): Observable<object> {
    return this.http.get<object>(this.url + "/office365/" + id + "/users");
  }

}
